/* eslint-disable @nx/enforce-module-boundaries */
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { RoutesValues } from '../../../common/enums/routes.enum';

export const ADMIN_AUTH_GUARD = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const isAdmin = authService.isAdmin();
  if (isAdmin) return true;
  router.navigate([RoutesValues.FORBIDDEN]);
  return false;
};
